
    <ng-container *ngIf="isLoading; else changePasswordTemplate">
      <div class="row">
        <div class="col-sm-10 offset-sm-1 col-md-10 offset-md-1 offset-lg-2 col-lg-7 col-xl-4 offset-xl-3">
          <gt-loading></gt-loading>
        </div>
      </div>
    </ng-container>


    <ng-template #changePasswordTemplate>
      <section>
        <!---Change Password Form--->
        <section class="row login-container w-185">
          <header class="mb-7">
            <div class="text-12gpx font-bold font-body-bold opacity-90 text-text-default">Change Password</div>
          </header>
          <div class="form-container w-185 flex flex-col">
            <form name="form" #changePassword="ngForm" (ngSubmit)="onSubmit()" novalidate>
              <div class="form-group mb-0">
                <ng-container *ngIf="errorMessage && changePassword.valid">
                  <div class="mb-4">
                    <div class="flex flex-row p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                        <div class="flex flex-col pl-1">
                            <div class="opacity-90 text-7gpx text-text-default font-body">
                                {{errorMessage}}
                            </div>
                        </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="form-group">
                <label for="currentPassword" class="mb-2 text-6gpx block font-semibold text-title-default font-body-semibold">Current Password</label>
                <input type="password"
                        class="form-control placeholder-gray-300 h-21 w-full text-text-default border border-solid rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-body-bold font-bold"
                        name="currentPassword"
                        id="currentPassword"
                        autocomplete="off"
                        placeholder="Current Password"
                        [(ngModel)]="changePwdForm.currentPassword"
                        #currentPassword="ngModel"
                        (ngModelChange)="errorMessage=''"
                        required/>
                <div class="text-danger-400 text-xs mt-0.2" *ngIf="currentPassword.invalid && (currentPassword.dirty || isSubmitted)">Enter a Current password.</div>
              </div>
              <div class="form-group pwd-policy-wrapper">
                <label for="newPassword" class="mb-2 text-6gpx block font-semibold text-title-default font-body-semibold">New Password</label>
                
                <ng-container *ngIf="passwordPolicy.policyEnabled && showPolicy">
                  <div class="policy-box bg-white w-full px-6 py-2 h-auto shadow-md font-body mx-auto">
                    <ul class="list-unstyled w-full">
                      <div class="text-text-default flex justify-between mb-2">
                        <h6 class="text-6gpx font-body-semibold">Password Policy</h6>
                      </div>
                      <div class="relative">
                        <div class="overflow-hidden mb-4 text-xs flex rounded bg-secondary-100 h-0.2 bg-std-background">
                          <div class="hr-inner" [ngStyle]="{width: getPassedChecksPercentage}"></div>
                        </div>
                      </div>
                      <li class="pwd-policy-item">
                        <div class="gt-icon"
                             [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('minlength')) && newPassword.dirty,
                                          'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('minlength')))}"></div>
                        <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('minlength') && newPassword.dirty) ? '#48A84D' : ''}">
                          {{passwordPolicyNote?.minimumPasswordLength}}
                        </p>
                      </li>
                      <li class="pwd-policy-item">
                        <div class="gt-icon"
                             [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('maxlength')) && newPassword.dirty,
                                          'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('maxlength')))}"></div>
                        <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('maxlength') && newPassword.dirty) ? '#48A84D' : ''}">
                          {{passwordPolicyNote?.maximumPasswordLength}}
                        </p>
                      </li>
                      <li class="pwd-policy-item" *ngIf="passwordPolicy.complexity">
                        <div class="gt-icon"
                             [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('pattern')) && newPassword.dirty,
                                          'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('pattern')))}"></div>
                        <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('pattern') && newPassword.dirty) ? '#48A84D' : ''}">
                          {{passwordPolicyNote?.complexity}}
                        </p>
                      </li>
                      <li class="pwd-policy-item" *ngIf="passwordPolicy.allowedSpecialChar && !passwordPolicy.complexity">
                        <div class="gt-icon"
                             [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('pattern')) && newPassword.dirty,
                                          'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('pattern')))}"></div>
                        <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('pattern') && newPassword.dirty) ? '#48A84D' : ''}">
                          {{passwordPolicyNote?.allowedSpecialChar}}
                        </p>
                      </li>
                      <li *ngIf="passwordPolicy.memory" class="pwd-policy-item">
                        <div class="gt-icon pwd-policy-text ml-0 text-right">4.</div>
                        <p class="pwd-policy-text w-100">{{ passwordPolicyNote?.memory}}</p>
                      </li>
                      <li *ngIf="passwordPolicy.maxPasswordAge" class="pwd-policy-item">
                        <div class="gt-icon pwd-policy-text ml-0 text-right">5.</div>
                        <p class="pwd-policy-text w-100">
                          {{passwordPolicyNote?.maxPasswordAge}}
                        </p>
                      </li>
                      <li *ngIf="passwordPolicy.newPwdChangeDays" class="pwd-policy-item">
                        <div class="gt-icon pwd-policy-text ml-0 text-right">6.</div>
                        <p class="pwd-policy-text w-100">
                          {{passwordPolicyNote?.newPwdChangeDays}}
                        </p>
                      </li>
                    </ul>
                  </div>
                </ng-container>

                <input type="password"
                        class="form-control placeholder-gray-300 h-21 w-full text-text-default border border-solid rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-body-bold font-bold pwd-input"
                        name="newPassword"
                        id="newPassword"
                        autocomplete="off"
                        placeholder="New Password"
                        [(ngModel)]="changePwdForm.newPassword"
                        [minlength]="passwordPolicy.policyEnabled ? passwordPolicy.minimumPasswordLength: null"
                        [maxlength]="passwordPolicy.policyEnabled ? passwordPolicy.maximumPasswordLength: null"
                        [pattern]="passwordPolicy.policyEnabled ? passwordPolicy.pwdRegex: null"
                        #newPassword="ngModel"
                        (ngModelChange)="onDataChange($event)"
                        (focus)="onPasswordFocus()"
                        (blur)="onPasswordBlur()"
                        [ngClass]="{'border-danger':confirmPassword?.errors?.equalTo && isSubmitted && changePassword.invalid
                        && currentPassword?.valid && (!newPassword?.errors?.required && !confirmPassword?.errors?.required)}"
                        required/>
                <div class="text-danger-400 text-xs mt-0.2" *ngIf="(newPassword.invalid && (newPassword.dirty || isSubmitted)) && !newPassword.errors?.required">Password doesn't match the policy guidelines.</div>
                <div class="text-danger-400 text-xs mt-0.2" *ngIf="newPassword.errors?.required && (newPassword.dirty || isSubmitted)">Enter a new password.</div>
              </div>
              <div class="form-group">
                <label for="confirmPassword" class="mb-2 text-6gpx block font-semibold text-title-default font-body-semibold">Confirm Password</label>
                <input type="password"
                        class="form-control placeholder-gray-300 h-21 text-text-default border border-solid w-full rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-bold font-body-bold"
                        name="confirmPassword"
                        id="confirmPassword"
                        placeholder="Confirm Password"
                        autocomplete="off"
                        [(ngModel)]="changePwdForm.confirmPassword"
                        [minlength]="passwordPolicy.policyEnabled ? passwordPolicy.minimumPasswordLength: null"
                        [maxlength]="passwordPolicy.policyEnabled ? passwordPolicy.maximumPasswordLength: null"
                        [pattern]="passwordPolicy.policyEnabled ? passwordPolicy.pwdRegex: null"
                        #confirmPassword="ngModel"
                        (ngModelChange)="errorMessage=''"
                        [equalTo]="newPassword"
                        [ngClass]="{'border-danger':confirmPassword?.errors?.equalTo && isSubmitted && changePassword.invalid
                        && currentPassword?.valid && (!newPassword?.errors?.required && !confirmPassword?.errors?.required)}"
                        required/>
                <div class="text-danger-400 text-xs mt-0.2" *ngIf="(confirmPassword.errors?.required) && (confirmPassword.dirty || isSubmitted)">Enter a confirm password.</div>
                <div class="text-danger-400 text-xs mt-0.2" *ngIf="confirmPassword?.errors?.equalTo && isSubmitted && changePassword.invalid
                && currentPassword?.valid && (!newPassword?.errors?.required && !confirmPassword?.errors?.required)">Passwords do not match, please re-enter.</div>
              </div>
              <div class="form-group mb-0">
                <button 
                class="mb-4 bg-primary h-21 items-center justify-center text-white flex w-full text-7gpx font-semibold font-body-semibold rounded-gt-md-3">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </section>


      </section>

    </ng-template>
